'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookTheme = require('@narvar/nth-hook-theme');
var React = require('react');
var reactRemark = require('react-remark');
var TextLink = require('@narvar/nth-bit-text-link');
var Typography = require('../Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

/**
 * Component to be used for rendering strings with markdown content.
 * Currently only supports rendering links. Other options can be added as needed.
 */
const Markdown = _ref => {
  let {
    markdown
  } = _ref;
  const {
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(reactRemark.Remark, {
    rehypeReactOptions: {
      components: {
        // Links will follow the primary link styling of the retailers theme,
        // but be sized according to the text it's contained within.
        a: _ref2 => {
          let {
            children,
            href
          } = _ref2;
          return /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
            href: href,
            linkStyle: {
              sDefault: {
                ...linksNoneDefault,
                fontSize: 'inherit'
              },
              sHover: {
                ...linksNoneHover,
                fontSize: 'inherit'
              }
            },
            target: TextLink.TextLinkTargetType.BLANK
          }, children);
        },
        // Remark will by default wrap text in a paragraph tag. So ensure we use our
        // paragraph body text styling
        p: _ref3 => {
          let {
            children
          } = _ref3;
          return /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, null, children);
        }
      }
    }
  }, markdown);
};
var Markdown$1 = nthHookTheme.withThemeProvider(Markdown, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover']
});

exports["default"] = Markdown$1;
